<template>
  <div class="banner-management">
    <div class="header">
      <h2>外部广告管理</h2>
      <el-button type="primary" icon="el-icon-plus" @click="handleCreate">
        新增广告
      </el-button>
    </div>

    <div class="filter-bar">
      <el-select v-model="filterStatus" placeholder="按状态筛选" clearable @change="loadBannerList">
        <el-option label="全部" :value="null"></el-option>
        <el-option label="启用" :value="1"></el-option>
        <el-option label="禁用" :value="0"></el-option>
      </el-select>

      <el-input
        v-model="keyword"
        placeholder="搜索标题或描述"
        clearable
        style="width: 300px; margin-left: 10px"
        @keyup.enter.native="loadBannerList"
      >
        <el-button slot="append" icon="el-icon-search" @click="loadBannerList"></el-button>
      </el-input>

      <el-button type="primary" icon="el-icon-refresh" @click="loadBannerList" style="margin-left: 10px">
        刷新
      </el-button>
    </div>

    <el-table
      :data="bannerList"
      v-loading="loading"
      style="width: 100%; margin-top: 20px"
      border
    >
      <el-table-column prop="id" label="ID" width="80"></el-table-column>

      <el-table-column prop="title" label="标题" min-width="150"></el-table-column>

      <el-table-column prop="imageUrl" label="图片" width="120">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.imageUrl"
            :src="scope.row.imageUrl"
            :preview-src-list="[scope.row.imageUrl]"
            fit="cover"
            style="width: 80px; height: 45px; cursor: pointer"
          ></el-image>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column prop="description" label="描述" min-width="200" show-overflow-tooltip></el-table-column>

      <el-table-column prop="linkType" label="链接类型" width="100">
        <template slot-scope="scope">
          <el-tag size="small">{{ getLinkTypeName(scope.row.linkType) }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="linkParams" label="链接参数" min-width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.linkParams || '-' }}
        </template>
      </el-table-column>

      <el-table-column prop="sortOrder" label="排序" width="80"></el-table-column>

      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            @change="handleStatusChange(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>

      <el-table-column prop="clickCount" label="点击量" width="100"></el-table-column>

      <el-table-column prop="startTime" label="开始时间" width="160">
        <template slot-scope="scope">
          {{ formatTime(scope.row.startTime) }}
        </template>
      </el-table-column>

      <el-table-column prop="endTime" label="结束时间" width="160">
        <template slot-scope="scope">
          {{ formatTime(scope.row.endTime) }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">
            编辑
          </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 20px; text-align: right"
    >
    </el-pagination>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="800px"
      @close="handleDialogClose"
    >
      <el-form :model="formData" :rules="formRules" ref="bannerForm" label-width="100px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="formData.title" placeholder="请输入广告标题"></el-input>
        </el-form-item>

        <el-form-item label="描述" prop="description">
          <el-input
            type="textarea"
            v-model="formData.description"
            placeholder="请输入广告描述"
            :rows="3"
          ></el-input>
        </el-form-item>

        <el-form-item label="图片" prop="imageUrl">
          <el-upload
            :action="uploadAction"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :before-upload="beforeUpload"
            accept="image/*"
            drag
          >
            <div v-if="formData.imageUrl" style="position: relative">
              <el-image
                :src="formData.imageUrl"
                fit="cover"
                style="width: 300px; height: 168px; display: block"
              ></el-image>
              <div style="margin-top: 8px; text-align: center; color: #909399; font-size: 12px">
                点击或拖拽图片到此处重新上传
              </div>
            </div>
            <div v-else>
              <i class="el-icon-upload" style="font-size: 67px; color: #c0c4cc"></i>
              <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">支持jpg/png/gif等图片格式，建议尺寸1600x500</div>
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="链接类型" prop="linkType">
          <el-select v-model="formData.linkType" placeholder="请选择链接类型">
            <el-option label="AMC课程" value="amc"></el-option>
            <el-option label="袋鼠数学" value="kangaroo"></el-option>
            <el-option label="GESP编程" value="gesp"></el-option>
            <el-option label="课程介绍" value="intro"></el-option>
            <el-option label="外部链接" value="external"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="链接参数" prop="linkParams">
          <el-input
            v-model="formData.linkParams"
            placeholder='JSON格式，例如：{"level":"amc8"}'
          ></el-input>
          <div style="color: #909399; font-size: 12px; margin-top: 5px">
            示例：AMC课程 {"level":"amc8"}，袋鼠数学 {"level":1}
          </div>
        </el-form-item>

        <el-form-item label="排序" prop="sortOrder">
          <el-input-number
            v-model="formData.sortOrder"
            :min="0"
            :max="999"
            placeholder="数字越小越靠前"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="formData.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="开始时间">
          <el-date-picker
            v-model="formData.startTime"
            type="datetime"
            placeholder="选择开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="结束时间">
          <el-checkbox v-model="formData.isPermanent" @change="handlePermanentChange" style="margin-bottom: 10px">
            永久有效
          </el-checkbox>
          <el-date-picker
            v-model="formData.endTime"
            type="datetime"
            placeholder="选择结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
            :disabled="formData.isPermanent"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BannerManagement',
  data() {
    return {
      loading: false,
      bannerList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      filterStatus: null,
      keyword: '',
      dialogVisible: false,
      dialogTitle: '新增广告',
      submitting: false,
      uploadAction: '/api/file/uploadTo/banner',
      uploadHeaders: {
        Authorization: localStorage.getItem('token') || ''
      },
      formData: {
        id: null,
        title: '',
        description: '',
        imageUrl: '',
        linkType: 'amc',
        linkParams: '',
        sortOrder: 0,
        status: 1,
        startTime: null,
        endTime: null,
        isPermanent: false
      },
      formRules: {
        title: [
          { required: true, message: '请输入广告标题', trigger: 'blur' },
          { max: 100, message: '标题长度不能超过100个字符', trigger: 'blur' }
        ],
        imageUrl: [
          { required: true, message: '请上传广告图片', trigger: 'change' }
        ],
        linkType: [
          { required: true, message: '请选择链接类型', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.loadBannerList()
  },
  methods: {
    async loadBannerList() {
      this.loading = true
      try {
        const response = await axios.get('/api/banner/page', {
          params: {
            current: this.currentPage,
            size: this.pageSize,
            status: this.filterStatus,
            keyword: this.keyword
          }
        })
        if (response.data.code === 200 || response.data.code === 1) {
          this.bannerList = response.data.data.records
          this.total = response.data.data.total
        } else {
          this.$message.error(response.data.msg || response.data.message || '加载失败')
        }
      } catch (error) {
        console.error('加载广告列表失败:', error)
        this.$message.error('加载广告列表失败')
      } finally {
        this.loading = false
      }
    },
    handleCreate() {
      this.dialogTitle = '新增广告'
      this.resetForm()
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑广告'
      this.formData = {
        id: row.id,
        title: row.title,
        description: row.description,
        imageUrl: row.imageUrl,
        linkType: row.linkType,
        linkParams: row.linkParams,
        sortOrder: row.sortOrder,
        status: row.status,
        startTime: row.startTime,
        endTime: row.endTime,
        isPermanent: !row.endTime
      }
      this.dialogVisible = true
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除这条广告吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const response = await axios.delete(`/api/banner/${row.id}`)
        if (response.data.code === 200 || response.data.code === 1) {
          this.$message.success('删除成功')
          this.loadBannerList()
        } else {
          this.$message.error(response.data.msg || response.data.message || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除广告失败:', error)
          this.$message.error('删除广告失败')
        }
      }
    },
    async handleStatusChange(row) {
      try {
        const response = await axios.put(`/api/banner/${row.id}/status`, null, {
          params: { status: row.status }
        })
        if (response.data.code === 200 || response.data.code === 1) {
          this.$message.success('状态更新成功')
        } else {
          this.$message.error(response.data.msg || response.data.message || '状态更新失败')
          row.status = row.status === 1 ? 0 : 1
        }
      } catch (error) {
        console.error('更新状态失败:', error)
        this.$message.error('更新状态失败')
        row.status = row.status === 1 ? 0 : 1
      }
    },
    handleSubmit() {
      this.$refs.bannerForm.validate(async (valid) => {
        if (!valid) return

        if (!this.formData.imageUrl) {
          this.$message.error('请上传广告图片')
          return
        }

        this.submitting = true
        try {
          const submitData = { ...this.formData }
          if (submitData.isPermanent) {
            submitData.endTime = null
          }
          delete submitData.isPermanent

          let response
          if (submitData.id) {
            response = await axios.put(`/api/banner/${submitData.id}`, submitData)
          } else {
            response = await axios.post('/api/banner', submitData)
          }

          if (response.data.code === 200 || response.data.code === 1) {
            this.$message.success(submitData.id ? '更新成功' : '创建成功')
            this.dialogVisible = false
            this.loadBannerList()
          } else {
            this.$message.error(response.data.msg || response.data.message || '操作失败')
          }
        } catch (error) {
          console.error('提交失败:', error)
          this.$message.error('操作失败')
        } finally {
          this.submitting = false
        }
      })
    },
    handleDialogClose() {
      this.$refs.bannerForm.resetFields()
      this.resetForm()
    },
    resetForm() {
      this.formData = {
        id: null,
        title: '',
        description: '',
        imageUrl: '',
        linkType: 'amc',
        linkParams: '',
        sortOrder: 0,
        status: 1,
        startTime: null,
        endTime: null,
        isPermanent: false
      }
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!')
        return false
      }
      return true
    },
    handleUploadSuccess(response, file) {
      if (response.code === 200 || response.code === 1) {
        this.formData.imageUrl = response.data.url || response.data
        this.$message.success('图片上传成功')
      } else {
        this.$message.error(response.msg || response.message || '图片上传失败')
      }
    },
    handleUploadError(err) {
      console.error('上传失败:', err)
      this.$message.error('图片上传失败')
    },
    handlePermanentChange(val) {
      if (val) {
        this.formData.endTime = null
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadBannerList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadBannerList()
    },
    formatTime(time) {
      if (!time) return '-'
      return time.replace('T', ' ').substring(0, 19)
    },
    getLinkTypeName(type) {
      const typeMap = {
        amc: 'AMC课程',
        kangaroo: '袋鼠数学',
        gesp: 'GESP编程',
        intro: '课程介绍',
        external: '外部链接'
      }
      return typeMap[type] || type
    }
  }
}
</script>

<style scoped>
.banner-management {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header h2 {
  margin: 0;
  font-size: 24px;
  color: #303133;
}

.filter-bar {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.dialog-footer {
  text-align: right;
}
</style>
